import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import styled from 'styled-components';
import FONTS from 'assets/fonts';
const SweatTubeLink = (props) => {
    const { match, location } = props;
    const { params } = match;
    const deeplink = `sweattube://${params.path || ''}${location.search}`;
    useEffect(() => {
        window.location.href = deeplink;
    }, [deeplink]);
    return (_jsx(Section, { children: _jsxs(Container, { children: [_jsx(Title, { children: "Opening SweatTube..." }), _jsxs(Subtitle, { children: ["If the app doesn't open automatically,", ' ', _jsx(DeeplinkAnchor, { href: deeplink, children: "tap here" }), "."] })] }) }));
};
const Section = styled.section `
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
`;
const Container = styled.div `
  text-align: center;
  padding: 30px;
`;
const Title = styled.h1 `
  font-family: ${FONTS.SimplonNormBold.name}, ${FONTS.fallback};
  font-size: 32px;
  color: #ffffff;
  margin: 0 0 16px;
`;
const Subtitle = styled.p `
  font-family: ${FONTS.SimplonNorm.name}, ${FONTS.fallback};
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
`;
const DeeplinkAnchor = styled.a `
  color: #ffffff;
  text-decoration: underline;
`;
export default SweatTubeLink;
